import Vue from "vue";
import Vuex from "vuex";
import ConstantInfoStore from "@/store/ConstantInfoStore";
import LoginInfoStore from "@/store/LoginInfoStore";
import ReservationInfoStore from "@/store/ReservationStore";
import TrainingInfoStore from "@/store/TrainingInfoStore";
import UserInfoStore from "@/store/UserInfoStore";
import EventInfoStore from "@/store/EventInfoStore";
import guestTrainingInfoStore from "@/store/guestTrainingInfoStore";
import guestReservationInfoStore from "@/store/guestReservationStore";
import AdminTrainingInfoStore from "@/store/AdminTrainingInfoStore";
import AdminEventInfoStore from "@/store/AdminEventInfoStore";
import AdminMemberInfoStore from "@/store/AdminMemberInfoStore";
import AdminReservationInfoStore from "@/store/AdminReservationStore";
import UserListStore from "@/store/UserListStore";
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    constantStore: {
      namespaced: true,
      modules: {
        constant: {
          namespaced: true,
          modules: {
            constantStore: ConstantInfoStore
          }
        }
      }
    },
    loginStore: {
      namespaced: true,
      modules: {
        loginInfo: {
          namespaced: true,
          modules: {
            loginInfoStore: LoginInfoStore
          }
        }
      }
    },
    reservationStore: {
      namespaced: true,
      modules: {
        reservationInfo: {
          namespaced: true,
          modules: {
            reservationInfoStore: ReservationInfoStore,
            guestReservationInfoStore: guestReservationInfoStore
          }
        }
      }
    },
    trainingInfoStore: {
      namespaced: true,
      modules: {
        trainingInfo: {
          namespaced: true,
          modules: {
            trainingInfoStore: TrainingInfoStore,
            guestTrainingInfoStore: guestTrainingInfoStore
          }
        }
      }
    },
    userInfoStore: {
      namespaced: true,
      modules: {
        userInfo: {
          namespaced: true,
          modules: {
            userInfoStore: UserInfoStore
          }
        }
      }
    },
    eventInfoStore: {
      namespaced: true,
      modules: {
        eventInfo: {
          namespaced: true,
          modules: {
            eventInfoStore: EventInfoStore
          }
        }
      }
    },
    adminTrainingInfoStore: {
      namespaced: true,
      modules: {
        adminTrainingInfo: {
          namespaced: true,
          modules: {
            adminTrainingInfoStore: AdminTrainingInfoStore
          }
        }
      }
    },
    adminEventInfoStore: {
      namespaced: true,
      modules: {
        adminEventInfo: {
          namespaced: true,
          modules: {
            adminEventInfoStore: AdminEventInfoStore
          }
        }
      }
    },
    adminMemberInfoStore: {
      namespaced: true,
      modules: {
        adminMemberInfo: {
          namespaced: true,
          modules: {
            adminMemberInfoStore: AdminMemberInfoStore
          }
        }
      }
    },
    adminReservationStore: {
      namespaced: true,
      modules: {
        adminReservationInfo: {
          namespaced: true,
          modules: {
            adminReservationInfoStore: AdminReservationInfoStore
          }
        }
      }
    },
    adminUserListStore: {
      namespaced: true,
      modules: {
        adminUserList: {
          namespaced: true,
          modules: {
            adminUserListStore: UserListStore
          }
        }
      }
    }
  }
});
